import { Participant } from 'livekit-client';
import { CallParticipant } from '../common/interfaces/rtc-interface';
import { IconConfig, IconTypes } from '../standalones/components/pencil-icon/pencil-icon.component';

// to break circular dependency
export enum ObserverModeSuffix {
  OBSERVER = '_observer',
}

export const OBSERVER_MODE_LEARN_MORE_URL =
  'https://helpdesk.pencilspaces.com/en/articles/15422204-how-to-use-observer-mode';

export const OBSERVER_BLACK_ICON_CONFIG: IconConfig = {
  name: 'observer-black',
  type: IconTypes.svgIcon,
};

export const OBSERVER_WHITE_ICON_CONFIG: IconConfig = {
  name: 'observer-white',
  type: IconTypes.svgIcon,
};

const OBSERVER_CALL_PARTICIPANT_ID_SUFFIX = 'observer';

/** True when the tab/session unique hash marks a space observer (e.g. `_observer` suffix). */
export function isObserverTabId(uniqueHash: string): boolean {
  if (!uniqueHash) {
    return false;
  }
  return uniqueHash.includes(ObserverModeSuffix.OBSERVER);
}

export function isObserverCallParticipant(participant: CallParticipant): boolean {
  return participant.participantId.includes(OBSERVER_CALL_PARTICIPANT_ID_SUFFIX);
}

export function isObserverParticipant(participant: Participant): boolean {
  return participant.identity.includes(OBSERVER_CALL_PARTICIPANT_ID_SUFFIX);
}
